import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './index.css'

export default class SelectField extends Component {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    error: PropTypes.string,
    availableValues: PropTypes.array.isRequired,
    placeholder: PropTypes.string,
    wrapperClass: PropTypes.string
  }

  static defaultProps = {
    value: "",
    placeholder: "",
    wrapperClass: "form-group"
  }

  handleChange = (option) => {
    const { onChange } = this.props
    onChange && onChange(option.value)
  }

  render() {
    const { wrapperClass, name, label, value, error, availableValues, placeholder } = this.props

    // Allow either strings to be passed or key/values of the format:
    // {label: 'foo', value: 'bar'}
    const options = availableValues.map((val) => {
      return typeof(val) === "string" ? {label: val, value: val} : val
    })

    return (
      <div className={wrapperClass}>
        { label && <label>{ label }</label> }
        <Select
          name={name}
          className='selectbox'
          placeholder={placeholder}
          options={options}
          onChange={this.handleChange}
          value={value}
        />
        { error && <div className="error">{ error}</div> }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SelectField/index.js